export class ActivateWorkOrderRequest {

    public workOrderId: string = "";

    public sendNotification: boolean = false;

    public comment: string | null = null;
}